import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseQueryOptions<string[], Error>, 'queryKey' | 'queryFn'>
}

export const useStagingGatewaysRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<string[], Error>(
    [Entities.Configuration, 'get-staging-gateways'],
    async () => {
      const { data } = await api.v1AdminConfigurationGatewayAllocationGet()
      return data as string[]
    },
    options
  )
}
